// A lista pública de tools do backend, copiada byte a byte de
// `aawz_intelligence_v2/contratos/tools-publicas.json` ([T020] da spec-010).
// É o que alimenta `FRAMEWORK_TOOL_NAMES` — ver o comentário lá embaixo.
import toolsPublicas from '@modules/aawz-intelligence-v2/ui-registry/contratos/tools-publicas.json'
// Memória curada — texto vive em arquivo próprio (Text.js já estava perto do
// teto de 500 linhas antes desta tela); reexportado aqui para quem importa
// `MEMORIA_TEXT` de `constants/Text` continuar funcionando ([T016]).
import { MEMORIA_TEXT } from './Text.memoria'
// Pendências de promoção a Knowledge oficial (spec-013, r3, [T030]) — arquivo
// próprio, mesmo molde de `Text.memoria`/`Text.aprendizado` (este arquivo já
// estava no teto de 500 linhas antes desta task).
import {
  KNOWLEDGE_PENDENCIA_HEADERS,
  KNOWLEDGE_PENDENCIA_ORIGEM_CORES,
  KNOWLEDGE_PENDENCIA_ORIGEM_LABELS,
  PENDENCIAS_TEXT,
} from './Text.conhecimento-pendencias'
// Aprovação de skills por risco (spec-007) — mesmo padrão de `Text.memoria`:
// arquivo próprio, reexportado aqui ([T021]).
import {
  ABAS_APRENDIZADO,
  ACOES_TEXT,
  APRENDIZADO_TEXT,
  DOMINIO_FILTRO_OPTIONS,
  EVAL_LABELS,
  FONTE_OPTIONS,
  LIFECYCLE_FILTRO_OPTIONS,
  ORIGEM_LABELS,
  ORIGEM_OPTIONS,
  PERIODO_OPTIONS,
  RESOURCE_TYPE_OPTIONS,
  RISCO_COLORS,
  RISCO_LABELS,
  RISCO_MOTIVO_LABELS,
  RISCO_OPTIONS,
  SCOPE_FILTRO_OPTIONS,
  SCOPE_OPTIONS,
  SKILLS_LEDGER_HEADERS,
  SKILLS_TABLE_HEADERS,
  SKILLS_TEXT,
  humanizarMotivoDeRisco,
} from './Text.aprendizado'
// Métricas da IA (spec-012-avaliacao-e-metricas-de-aprendizado) — mesmo
// padrão de `Text.memoria`/`Text.aprendizado`: arquivo próprio, reexportado
// aqui ([T027]).
import {
  ALVO_LABELS,
  METRICAS_PERIODO_OPTIONS,
  METRICAS_TEXT,
  SECOES_METRICAS,
  STATUS_EVAL_CORES,
  STATUS_EVAL_LABELS,
} from './Text.metricas'

export { MEMORIA_TEXT }

export {
  KNOWLEDGE_PENDENCIA_HEADERS,
  KNOWLEDGE_PENDENCIA_ORIGEM_CORES,
  KNOWLEDGE_PENDENCIA_ORIGEM_LABELS,
  PENDENCIAS_TEXT,
}

export {
  ABAS_APRENDIZADO,
  ACOES_TEXT,
  APRENDIZADO_TEXT,
  DOMINIO_FILTRO_OPTIONS,
  EVAL_LABELS,
  FONTE_OPTIONS,
  LIFECYCLE_FILTRO_OPTIONS,
  ORIGEM_LABELS,
  ORIGEM_OPTIONS,
  PERIODO_OPTIONS,
  RESOURCE_TYPE_OPTIONS,
  RISCO_COLORS,
  RISCO_LABELS,
  RISCO_MOTIVO_LABELS,
  RISCO_OPTIONS,
  SCOPE_FILTRO_OPTIONS,
  SCOPE_OPTIONS,
  SKILLS_LEDGER_HEADERS,
  SKILLS_TABLE_HEADERS,
  SKILLS_TEXT,
  humanizarMotivoDeRisco,
}

export {
  ALVO_LABELS,
  METRICAS_PERIODO_OPTIONS,
  METRICAS_TEXT,
  SECOES_METRICAS,
  STATUS_EVAL_CORES,
  STATUS_EVAL_LABELS,
}

// Abas do módulo AAWZ Intelligence — fonte única do título/subtítulo do
// header (NavBarNavigation route-header + ConditionalTeleport), igual ao
// crmRoutes() do CRM. Nomes de rota vivem no shell v1 (aawz-intelligence),
// mas o texto fica aqui em v2 porque é aqui que as views físicas moram.
export const aawzIntelligenceRoutes = () => [
  {
    name: 'aawz-intelligence.welcome',
    title: 'Bem-vindo',
    subtitle: 'Conheça o AAWZ Intelligence',
  },
  {
    name: 'aawz-intelligence.chat-ia',
    title: 'Chat IA',
    subtitle:
      'Converse com a IA sobre seus clientes, tarefas, oportunidades e pipeline de vendas',
  },
  {
    name: 'aawz-intelligence.curadoria',
    title: 'Sugestões a triar',
    subtitle:
      'Tudo o que a IA propôs a partir das reuniões espera aqui: revise, edite se precisar, e aceite ou descarte',
  },
  {
    name: 'aawz-intelligence.alteracoes-ia',
    title: 'Alterações da IA',
    subtitle: 'Histórico de alterações sugeridas pela IA',
  },
  {
    name: 'aawz-intelligence.chaves-api',
    title: API_KEYS_TEXT.pageTitle,
    subtitle: API_KEYS_TEXT.pageDescription,
  },
  {
    name: 'aawz-intelligence.memoria',
    title: MEMORIA_TEXT.pageTitle,
    subtitle: MEMORIA_TEXT.pageDescription,
  },
  // spec-007-aprovacao-de-skills-por-risco ([T021]) — as 3 abas novas, SEMPRE
  // no fim (T033 registra as rotas em `@modules/aawz-intelligence/routes.js`).
  {
    name: 'aawz-intelligence.aprendizado-ia',
    title: APRENDIZADO_TEXT.pageTitle,
    subtitle: APRENDIZADO_TEXT.pageDescription,
  },
  {
    name: 'aawz-intelligence.skills-ia',
    title: SKILLS_TEXT.pageTitle,
    subtitle: SKILLS_TEXT.pageDescription,
  },
  {
    name: 'aawz-intelligence.acoes-ia',
    title: ACOES_TEXT.pageTitle,
    subtitle: ACOES_TEXT.pageDescription,
  },
  // spec-013-knowledge-por-escritorio-e-promocao-de-decisao ([T007], §1 do
  // `contracts/ui-components.md`) — SEMPRE a ÚLTIMA aba do módulo (depois de
  // "Memória da IA" e das 3 da 007), nunca um ordinal fixo. A rota real
  // (`aawz-intelligence.conhecimento`) é registrada em `@modules/aawz-
  // intelligence/routes.js` pelo [T024], fora do escopo desta task.
  {
    name: 'aawz-intelligence.conhecimento',
    title: CONHECIMENTO_TEXT.pageTitle,
    subtitle: CONHECIMENTO_TEXT.pageDescription,
  },
  // spec-012-avaliacao-e-metricas-de-aprendizado ([T029], `contracts/ui-
  // components.md` §1) — SEMPRE a última aba, depois de "Conhecimento
  // oficial". A rota real (`aawz-intelligence.metricas-ia`) é registrada em
  // `@modules/aawz-intelligence/routes.js`.
  {
    name: 'aawz-intelligence.metricas-ia',
    title: METRICAS_TEXT.titulo,
    subtitle: METRICAS_TEXT.subtitulo,
  },
]

// spec-005/006/007 — painel de curadoria das sugestões de IA de UM ESCOPO
// (reunião OU cliente). Modal genérico e domain-agnostic: consolida os antigos
// TRANSCRIPT_SUGGESTIONS_MODAL (crm) e CLIENT_SUGGESTIONS_MODAL (crm) — a copy
// não referencia mais "reunião"/"cliente" (o `subtitulo` mostrado no corpo do
// modal já deixa o objeto claro; repetir na confirmação era redundante).
export const IA_SUGGESTIONS_MODAL = {
  titulo: 'Sugestões pendentes',
  semCliente: 'Sem cliente',
  abaPendentes: (n) => `Pendentes (${n})`,
  abaAprovadas: (n) => `Aprovadas (${n})`,
  abaRecusadas: (n) => `Recusadas (${n})`,
  abaTodas: (n) => `Todas (${n})`,
  acceptAll: 'Aceitar todas',
  declineAll: 'Recusar todas',
  cancelar: 'Cancelar',
  vazioTitulo: 'Nenhuma sugestão aqui',
  vazioDescricao: 'Não há sugestões nesta categoria.',
  erroTitulo: 'Não foi possível carregar as sugestões',
  erroDescricao: 'Tente novamente ou contate o suporte.',
  tentarNovamente: 'Tentar novamente',
  confirmAcceptAllTitulo: 'Aceitar todas as sugestões',
  confirmAcceptAll: (n) =>
    `Aceitar ${n} ${
      n === 1 ? 'sugestão' : 'sugestões'
    }? As entidades reais serão criadas.`,
  confirmDeclineAllTitulo: 'Recusar todas as sugestões',
  confirmDeclineAll: (n) =>
    `Recusar ${n} ${n === 1 ? 'sugestão' : 'sugestões'}? Nada será criado.`,
  edicaoNaoAbriu:
    'Não foi possível abrir a edição desta sugestão: o registro que ela aponta não está na lista carregada. Recarregue a página.',
}

// Texto sob aprovação de Compliance (AC-1.6). Fonte ÚNICA — duplicar a copy faz a cópia
// divergir exatamente no item que alguém aprovou.
export const AVISO_NAO_ACONSELHAMENTO =
  'As respostas são recomendação de negócio e não constituem parecer jurídico, ' +
  'regulatório, tributário ou recomendação de investimento.'

// Suporte no WhatsApp. Consumidor único: o cartão `suporte-whatsapp-card.vue`
// (estado vazio da `/home-ia` e pé do painel da conversa). Morou no rodapé do
// composer até 17/09/2026. O número é o TECH_CONTACT_NUMBER.
export const SUPORTE_WHATSAPP = Object.freeze({
  rotulo: 'Suporte no WhatsApp',
  // Linha de cima do cartão de suporte (`suporte-whatsapp-card.vue`):
  // o rótulo acima vira a linha FORTE, e esta é a pergunta que a precede.
  chamada: 'Precisa de ajuda?',
  // Verde da MARCA do WhatsApp — não é token do DS; vale só para o ícone.
  corDaMarca: '#25D366',
  mensagem: 'Olá, vim da Central de IA da AAWZ e preciso de suporte.',
})

// Rótulo do cartão de serviço citado (AC-4.1). Mora no módulo do motor, e não em
// `solicitacoes`: o consumidor é `servicos-citados.vue`, e a casca anticorrupção existe
// para impedir que `aawz-intelligence-v2` importe de `solicitacoes`.
// As chaves são o enum `RotuloServicoCitado` do backend — mudar uma faz o cartão
// renderizar rótulo vazio sem que lint ou exceção peguem.
export const ROTULO_SERVICO_CITADO = {
  obrigatorio_no_ciclo: 'Obrigatório no ciclo',
  opcional_no_ciclo: 'Opcional neste ciclo',
  o_que_vem_depois: 'O que vem depois',
}

// Labels PT-BR humanizadas para os nomes internos das tools.
// ★ Cobertura obrigatória (NC-3): nome interno de tool não pode virar pixel no
// meio da conversa. Consumidores hoje: a `run-timeline` do IA Framework
// (Execuções/Auditoria), cujo fallback é o genérico 'Consulta a dados', e a
// resolução de rótulo dos cartões do turno — que procura primeiro o `label` da
// PARTE, depois `entrada.label` do `UI_REGISTRY`, e só então este mapa. O
// `tool-call-badge` que as exibia durante o stream saiu em `a5412ef34`: quem
// mostra "o que a IA faz agora" passou a ser a linha de raciocínio, que o
// backend já emite com o `LABEL` da tool (`test_thinking_step_com_rotulo.py`).
// Tool sem rótulo não vaza mais o slug — vira um rótulo vago que não conta o
// que a IA fez, e `Text.tool-labels.unit.js` reprova quem não tem rótulo em
// lado nenhum, iterando a lista PÚBLICA do backend (nunca uma lista redigitada).
// ★ Quando o backend declara `LABEL` para a tool, o texto aqui é o MESMO — o
// mesmo teste compara os dois. Duas grafias do mesmo fato é como o fio diz uma
// coisa e a tela diz outra.
// Linguagem de NEGÓCIO, nunca o nome técnico da tool (AC-2.6): o rótulo é lido pelo cliente.
export const TOOL_LABELS = {
  echo_test: 'Testando...',
  // ★ As quatro tools do fan-out de 20/09 que a junta com `tools-publicas.json`
  // acusou sem rótulo. Nenhuma delas resolve pelo registry (o atalho manda
  // `ui.component` direto, sem entrada no `LEGACY_TOOL_TO_UI`), então o rótulo
  // do badge mora aqui — byte a byte o `LABEL` do `.py` de cada uma, como o
  // resto deste mapa exige. Sem eles o badge mostra o slug da tool enquanto ela
  // roda, que é o defeito que esta junta existe para pegar.
  get_nota_de_reuniao: 'Montando a nota da reunião...',
  segmentar_carteira: 'Lendo a sua carteira e aplicando a régua...',
  revisar_rebalanceamento: 'Revisão de rebalanceamento',
  priorizar_profissionais_fee_fixo: 'Lendo as carteiras do escritório...',
  // Leitura — clientes / carteira / financeiro
  get_cliente_resumo: 'Consultando cliente...',
  get_cliente_dados: 'Consultando dados do cliente...',
  // As três visões 360 do hermes (specs 008/009) não têm cartão no registry
  // (`tem_ui: false` no contrato) — o rótulo delas mora aqui, com o MESMO texto
  // do `LABEL` do backend (`tools-publicas.json`), senão o slug vira pixel.
  get_cliente_360: 'Consultando a visão 360 do cliente...',
  get_familia_360: 'Consultando a família do cliente...',
  get_office_360: 'Consultando a visão 360 do escritório...',
  // spec-004-compliance-cliente — o atalho `/compliance`. Byte a byte o
  // `LABEL` das duas tools (`tool_get_compliance_cliente.py`/
  // `tool_get_enquadramento_anbima.py`), como o resto deste mapa exige —
  // ficaram públicas em `tools-publicas.json` (135 → 137) sem entrada aqui,
  // e a junta `Text.tool-labels.unit.js` fechou o gap.
  get_compliance_cliente: 'Organizando as pendências por consequência...',
  get_enquadramento_anbima: 'Comparando a carteira com o teto do perfil...',
  search_cliente_by_nome: 'Buscando cliente...',
  list_clients: 'Consultando clientes...',
  list_clientes_carteira: 'Consultando clientes da carteira...',
  get_ativos_consolidados: 'Consultando ativos...',
  get_alocacao_por_classe: 'Consultando alocação da carteira...',
  get_estatisticas_carteira: 'Consultando estatísticas da carteira...',
  get_rentabilidade_carteira: 'Consultando rentabilidade...',
  get_evolucao_patrimonial: 'Consultando evolução patrimonial...',
  get_transacoes: 'Consultando transações...',
  get_movimentacoes_ativos: 'Consultando movimentações...',
  get_contas_bancarias: 'Consultando contas bancárias...',
  list_bank_accounts: 'Consultando contas bancárias...',
  list_assets: 'Consultando ativos...',
  list_asset_movements: 'Consultando movimentações de ativos...',
  consultar_book_produtos: 'Consultando produtos...',
  // Leitura — planejamento / simulações
  get_financial_planning_objetivos: 'Consultando objetivos financeiros...',
  get_simulacao_principal: 'Consultando simulação principal...',
  get_projecao_patrimonial: 'Consultando projeção patrimonial...',
  // Leitura — CRM / atendimento / comercial
  list_tarefas: 'Consultando tarefas...',
  list_pastas_tarefas: 'Consultando pastas e listas...',
  list_oportunidades: 'Consultando oportunidades...',
  list_atendimentos_recentes: 'Consultando atendimentos do cliente...',
  list_conversas_atendimento: 'Consultando atendimentos...',
  list_emails_crm: 'Consultando e-mails...',
  list_conversas_whatsapp: 'Consultando conversas de WhatsApp...',
  list_alertas_atrasados: 'Consultando alertas...',
  list_crm_atividades_sugeridas: 'Consultando atividades sugeridas...',
  get_funil_vendas: 'Consultando funil de oportunidades...',
  get_funil_leads: 'Consultando funil de leads...',
  list_crm_clientes_prioridade_relacionamento: 'Consultando clientes prioritários...',
  // À LETRA o `LABEL` de `tool_list_crm_leads_prioridade.py` e de
  // `tool_get_regua_relacionamento_do_cliente.py` — as duas desenham o cartão
  // `crm/clientes-prioritarios` pelo helper compartilhado, então nenhuma delas
  // tem tool emissora ÚNICA (ver `SCHEMA_DE_VARIAS_TOOLS`) e o rótulo do badge
  // sai daqui.
  list_crm_leads_prioridade: 'Consultando leads prioritários...',
  get_regua_relacionamento_do_cliente:
    'Consultando a régua de relacionamento do cliente...',
  get_performance_profissional: 'Consultando performance...',
  list_noticias_mercado: 'Lendo notícias do mercado...',
  // Leitura — compliance / KYC
  get_compliance_status: 'Consultando status de compliance...',
  consultar_kyc: 'Consultando KYC...',
  // Leitura — geração de links (não escreve dado de cliente)
  gerar_link_formulario: 'Gerando link de formulário...',
  gerar_link_ips: 'Gerando link de IPS...',
  // Escrita (preview) — a proposta aguarda aprovação de um gestor (RF6)
  create_tarefa: 'Preparando proposta de tarefa...',
  edit_tarefa: 'Preparando alteração de tarefa...',
  // spec-002 comentar-tarefa-tool — comentário ≠ descrição
  comentar_tarefa: 'Preparando comentário na tarefa...',
  create_oportunidade: 'Preparando proposta de oportunidade...',
  edit_oportunidade: 'Preparando alteração de oportunidade...',
  create_ativo: 'Preparando proposta de ativo...',
  create_movimentacao: 'Preparando proposta de movimentação...',
  edit_atividade_crm: 'Preparando alteração de atividade do CRM...',
  edit_cliente_dados: 'Preparando alteração de dados do cliente...',
  // [spec-011 QA it.1] tool pública nova (`tools-publicas.json`), sem
  // `tem_ui` — byte a byte com `tool_criar_cliente.py::LABEL`.
  criar_cliente: 'Cadastrando o cliente novo...',
  get_situacao_escritorio: 'Lendo a jornada do seu escritório...',
  list_catalogo_servicos: 'Consultando o catálogo de serviços...',
  get_servico_detalhe: 'Buscando o detalhe do serviço...',
  citar_servicos: 'Organizando os próximos passos...',
  // As quatro que faltavam (spec-001 `plataforma-por-chat`, [T017] / NC-3). As
  // três primeiras já rodavam e apareciam no badge como o SLUG cru (o fallback
  // do badge era `TOOL_LABELS[tool] || (tool + '...')` até a [T020]); a quarta
  // entrou junto por ser write-tool sem rótulo, como as irmãs acima. Toda tool
  // que ganha entrada no `UI_REGISTRY` precisa de rótulo aqui — é o que impede
  // o nome interno de virar pixel no meio da conversa.
  // `convocar_painel` saiu daqui na spec-015 [T014]: a tool foi aposentada no
  // backend (spec-011 Wave 7, `3f785f57e` — pipeline síncrono do painel
  // substituído) e não está mais em `tools-publicas.json` (83→82). O front
  // continuava com o rótulo morto porque a cópia do contrato nunca foi
  // refeita depois disso; `Text.tool-labels.unit.js` (chave "nenhuma chave de
  // TOOL_LABELS é rótulo órfão") acusa exatamente esse caso. `LEGACY_TOOL_TO_UI`
  // e `painel-deliberacao.js` continuam citando o nome porque ainda precisam
  // renderizar conversas HISTÓRICAS que chamaram a tool — só o rótulo do badge
  // (que só se aplica a turnos NOVOS) saiu.
  perguntar_ao_gestor: 'Preparando as perguntas em aberto...',
  mover_tarefas: 'Preparando movimentação de tarefas...',
  create_projeto_avaliacao: 'Preparando proposta de projeto de avaliação...',
  // ── Leitura — Fee Fixo ────────────────────────────────────────────────────
  // Estas cinco não têm `LABEL` no backend e não têm cartão no registry: sem
  // rótulo aqui, o badge cai no genérico e o console avisa. O texto é derivado
  // da `description` de cada uma em `tools/tool_fee_fixo.py`.
  get_premissas_fee_fixo: 'Consultando as premissas do escritório...',
  get_diagnostico_fee_fixo: 'Consultando o diagnóstico do cliente...',
  racional_migracao_cliente: 'Montando o racional de migração...',
  metodo_comercial_fee_fixo: 'Consultando o método comercial...',
  elegibilidade_da_base_fee_fixo: 'Rodando o funil de elegibilidade da base...',
  plano_de_acao_fee_fixo: 'Consultando o plano de ação do escritório...',
  impacto_da_migracao_fee_fixo: 'Projetando o impacto da migração no resultado...',
  modelo_de_remuneracao_fee_fixo: 'Consultando o modelo de remuneração do time...',
  plano_de_migracao_fee_fixo: 'Montando o plano de migração...',
  // spec-008-quem-migrar-clientes [T015]: a tool ganhou `LABEL` no backend
  // (crítico cruzado X-5) — texto IDÊNTICO ao `LABEL` de
  // `ToolPriorizarCarteiraFeeFixo` (`tool_fee_fixo_carteira.py`); o espelho
  // da spec-010 [T020] compara os dois byte a byte. O badge dela hoje já
  // caía no rótulo compartilhado do registry ("Clientes citados na
  // resposta", `fee-fixo/cliente-atalho-card`) — esta entrada é o rótulo
  // PRÓPRIO da tool, para quando ela não passar pelo registry.
  priorizar_carteira_fee_fixo: 'Consultando por quem começar a migração...',
  // ── As 8 tools públicas sem rótulo, achado do team-lead pós-[T021] (spec-007
  // — `tools-publicas.json` sincronizado byte a byte com o backend). O texto
  // aqui foi derivado da descrição de cada tool, nunca do nome interno
  // (AC-2.6/NC-3), porque as oito eram `label: None` no backend.
  //
  // ★ 16/09/2026: DUAS delas deixaram de ser — `get_indicador_bi` e
  // `list_dashboards_bi` ganharam `LABEL` no backend quando passaram a emitir
  // cartão (`tem_ui` exige rótulo lá). Os textos declarados divergiam DESTES em
  // quatro pontos; quem se alinhou foi o backend, porque o texto daqui já
  // existia e estava em uso. As duas linhas abaixo agora são espelho, não
  // fonte: há teste dos dois lados amarrando a igualdade byte a byte
  // (`test_bi_cartao_desenhavel.py`, as duas asserções de `LABEL`). Mexer numa
  // ponta sem a outra fica vermelho.
  // Leitura — BI v2 (`project-bi-ia`)
  get_indicador_bi: 'Consultando indicador do BI...',
  list_dashboards_bi: 'Consultando dashboards do BI...',
  // Escrita (sem two-step de aprovação — porta única de memória/perfil, spec-002)
  declarar_racional_discutido_fee_fixo:
    'Registrando o racional da migração discutido com o cliente...',
  declarar_item_dispensado_fee_fixo:
    'Registrando que o item não se aplica a este cliente...',
  memory: 'Registrando memória...',
  // Leitura — memória episódica (spec-003-memoria-episodica-busca-e-compactacao)
  session_context: 'Consultando o contexto da conversa...',
  session_search: 'Buscando em conversas anteriores...',
  // skill_manage: SOMENTE_SISTEMA (review/curator) — nunca chamada por agente
  // de foreground, mas ainda aparece na run-timeline (Execuções/Auditoria).
  skill_manage: 'Registrando a skill...',
  skill_search: 'Buscando skills...',
  skill_view: 'Consultando a skill...',
  // spec-013-knowledge-por-escritorio-e-promocao-de-decisao [T010]: nova tool
  // pública, sem cartão no registry (`tem_ui: false`). O texto é IDÊNTICO ao
  // `LABEL` que o backend declara em `tool_retrieve_knowledge.py` — a mesma
  // exigência do item (e) da junta acima, para as duas grafias não divergirem.
  retrieve_knowledge: 'Conhecimento oficial',
  // spec-014-agentes-de-dominio-do-hub-de-gestao [T012]/[T013]/[T014]/[T015],
  // US-6: as três tools novas, sem cartão no registry (`tem_ui: false`). O
  // texto é IDÊNTICO ao `LABEL` que o backend declara em cada classe de tool —
  // mesma exigência do item (e) acima.
  gerar_rascunho_entrega: 'Montando o rascunho da entrega...',
  analisar_risco_carteira: 'Analisando o risco da carteira...',
  gerar_apresentacao: 'Gerando a apresentação...',
  // spec-015-consolidacao-documentos-reunioes-aposentadorias [T014]: as
  // quatro tools novas (82→86), sem cartão no registry (`tem_ui: false`). O
  // texto é IDÊNTICO ao `LABEL` que o backend declara em cada classe de tool
  // (`tools/tool_ler_extrato.py`, `tool_comparar_carteira_com_extrato.py`,
  // `tool_diagnosticar_carteira.py`, `tool_preparar_reuniao.py`) — mesma
  // exigência do item (e) acima (`9fe2b2374` corrigiu a acentuação de
  // "diagnóstico"/"reunião" no backend; o front acompanha byte a byte).
  // spec-009-anexo-sem-trava [T006]/[T007], entrada pelo merge com
  // `desenvolvimento` (141→142): `ler_anexo_analise` lê o canal de ANÁLISE
  // (`aawz_intelligence_v2_anexos_analise`, "resuma este contrato"), que é
  // OUTRO canal do `ler_extrato` logo abaixo — aquele é carteira. Sem esta
  // entrada o badge imprime o nome interno: a tool já estava no contrato
  // (`ui-registry/contratos/tools-publicas.json`) e `TOOL_LABELS` é quem
  // alimenta o badge. Texto IDÊNTICO ao `LABEL` da classe no backend
  // (`tools/tool_ler_anexo_analise.py`), como o resto deste bloco.
  // ⚠️ Divergir do `LABEL` faz o badge dizer uma coisa e o cartão outra —
  // foi o defeito medido em 26/08/2026 com `list_atendimentos_recentes`.
  ler_anexo_analise: 'Lendo o anexo...',
  ler_extrato: 'Lendo o extrato anexado...',
  comparar_carteira_com_extrato: 'Comparando a carteira com o extrato...',
  diagnosticar_carteira: 'Rodando o diagnóstico da carteira...',
  preparar_reuniao: 'Preparando a reunião...',
  // spec-016-agente-especialista-fee-fixo [T005]/[T006]: as duas tools novas
  // (86→88), sem cartão no registry (`tem_ui: false`). O texto é IDÊNTICO ao
  // `LABEL` que o backend declara em cada classe de tool
  // (`tools/tool_importar_carteira_fee_fixo.py`,
  // `tools/tool_preparar_ensaio_fee_fixo.py`) — mesma exigência do item (e)
  // acima.
  importar_carteira_fee_fixo: 'Importando a carteira anexada...',
  preparar_ensaio_fee_fixo: 'Preparando o ensaio...',
  // spec-006-roteamento-fallback-apos-tentativa [T002]: a tool nova (88→89),
  // sem cartão no registry (`tem_ui: false`). O texto é IDÊNTICO ao `LABEL`
  // que o backend declara em `tools/tool_encaminhar_para_especialista.py` —
  // mesma exigência do item (e) acima.
  encaminhar_para_especialista: 'Verificando qual especialista atende...',
  // spec-010-r2-guiada-pelo-agente-com-transcricao [T005]/[T006]: quatro tools
  // novas (89→93). `status_da_proposta_r2` é a única com cartão no registry
  // (`fee-fixo/checklist-r2`, emitido DIRETO por `ui.component` — fora de
  // `LEGACY_TOOL_TO_UI`, então `rotuloDe` não a alcança pelo registry e cai
  // aqui) — as outras três são HERDADAS (contratos C2/C3/C4 de
  // `contracts/tools.md`), sem `ui.component` nenhum. Os quatro textos são
  // IDÊNTICOS ao `LABEL` de cada classe de tool (`tools/
  // tool_fee_fixo_proposta_r2.py`, `tool_get_transcricao_reuniao.py`,
  // `tool_popular_campos_reuniao.py`, `tool_criar_simulacao_planejamento.py`)
  // — mesma exigência do item (e) acima.
  status_da_proposta_r2: 'Consultando o status da proposta R2...',
  get_transcricao_reuniao: 'Lendo a transcrição da reunião...',
  popular_campos_da_reuniao: 'Lendo os campos que a reunião revelou...',
  criar_simulacao_planejamento: 'Simulando o plano financeiro do cliente...',
  // spec-010-r2-guiada-pelo-agente-com-transcricao [T010]/[T033], complemento
  // da [T006]/[T005]: a quinta tool nova (93→94), com cartão no registry
  // (`fee-fixo/deck-r2-protocolo`, emitido DIRETO por `ui.component` — fora de
  // `LEGACY_TOOL_TO_UI`, cai aqui pela mesma razão de `status_da_proposta_r2`).
  // O texto é IDÊNTICO ao `LABEL` que o backend declara em
  // `tools/tool_fee_fixo_proposta_r2_gerar.py` — mesma exigência do item (e)
  // acima.
  gerar_proposta_r2: 'Preparando o deck da proposta R2...',
  // spec-018-roteiro-do-video-responde-de-verdade [T002]/[T003]/[T007]/[T008b]:
  // as quatro tools que a rodada do roteiro acrescentou (95→99). Só
  // `exportar_planilha` tem cartão no registry (`fee-fixo/exportar-planilha`,
  // emitido DIRETO por `ui.component` — fora de `LEGACY_TOOL_TO_UI`, então
  // `rotuloDe` não a alcança pelo registry e cai aqui, mesma razão de
  // `status_da_proposta_r2`); as outras três são leitura sem cartão
  // (`tem_ui: false`). Os quatro textos são IDÊNTICOS ao `LABEL` de cada
  // classe (`tools/tool_exportar_planilha.py`,
  // `tool_plano_por_assessor_fee_fixo.py`, `tool_sinais_do_assessor.py`,
  // `tool_varrer_vencimento_e_caixa_da_carteira.py`) — mesma exigência do
  // item (e) acima.
  exportar_planilha: 'Montando a planilha...',
  plano_por_assessor_fee_fixo: 'Consultando o plano deste assessor...',
  sinais_do_assessor: 'Cruzando CRM, régua e reuniões...',
  varrer_vencimento_e_caixa_da_carteira:
    'Varrendo vencimento e caixa parado da carteira...',
  // spec-021 [T006]: a tool nova (99→100), sem cartão no registry
  // (`tem_ui: false` — o cartão `fee-fixo/apresentacao` é emitido por
  // `gerar_apresentacao`, não por ela). O texto é IDÊNTICO ao `LABEL` que o
  // backend declara em `aawz_fee_fixo/tools/tool_status_apresentacao.py` —
  // mesma exigência do item (e) acima.
  status_apresentacao_fee_fixo: 'Consultando o andamento da apresentação...',
  // Especialista em Comissionamento (rota dedicada `/comissoes/chat`). As 27 são
  // RESERVADAS no backend (`reservada=True, publica=False`), mas ESTÃO em
  // `FRAMEWORK_TOOL_NAMES` porque `tools-publicas.json` inclui as reservadas
  // (todas viram badge) — o badge que as anuncia é o mesmo componente, com o
  // mesmo fallback: sem label aqui a tela ecoa `get_regras_comissionamento...`
  // para o gestor. Cobertura travada por `COMISSOES_TOOL_NAMES` (abaixo).
  // Texto espelhado byte a byte do `LABEL` de cada tool no backend
  // (`aawz_intelligence_v2/tools/tool_comissoes*.py`) — divergir aqui faz a tela
  // anunciar uma coisa e o log do turno registrar outra.
  get_relatorio_comissionamento: 'Consultando o relatório de comissionamento...',
  listar_valores_de_filtro_comissoes:
    'Consultando os valores de filtro do comissionamento...',
  explicar_processo_comissionamento:
    'Consultando a explicação do comissionamento...',
  get_regras_comissionamento: 'Consultando as regras de comissionamento...',
  get_trocas_de_campo_comissionamento:
    'Consultando as trocas de campo do comissionamento...',
  get_listas_comissionamento: 'Consultando as listas do comissionamento...',
  get_variaveis_comissionamento:
    'Consultando as variáveis do comissionamento...',
  get_impostos_comissionamento: 'Consultando os impostos do comissionamento...',
  get_lancamentos_do_fechamento: 'Consultando os lançamentos do fechamento...',
  get_ajustes_manuais_comissionamento:
    'Consultando os ajustes manuais do comissionamento...',
  get_base_de_clientes_comissionamento:
    'Consultando a base de clientes do comissionamento...',
  get_arquivos_importados_comissionamento:
    'Consultando os arquivos importados de comissões...',
  get_minimos_garantidos_comissionamento: 'Consultando os mínimos garantidos...',
  // Fase 3 (`IA - Comissões - Ações`): a leitura de blocos e as 13 write-tools
  // da configuração. Espelho do `LABEL` de `tool_comissoes_blocos.py`,
  // `tool_comissoes_escrita_{blocos,linhas,listas_variaveis}.py`.
  listar_blocos_de_comissionamento: 'Consultando os blocos do comissionamento...',
  inserir_bloco_de_comissionamento:
    'Preparando a inserção de um bloco de comissionamento...',
  excluir_bloco_de_comissionamento:
    'Preparando a exclusão de um bloco de comissionamento...',
  mover_bloco_de_comissionamento:
    'Preparando a movimentação de um bloco de comissionamento...',
  renomear_bloco_de_comissionamento:
    'Preparando a renomeação de um bloco de comissionamento...',
  inserir_linha_de_comissionamento:
    'Preparando a inserção de uma linha de comissionamento...',
  editar_linha_de_comissionamento:
    'Preparando a edição de uma linha de comissionamento...',
  excluir_linha_de_comissionamento:
    'Preparando a exclusão de uma linha de comissionamento...',
  mover_linha_de_comissionamento:
    'Preparando a movimentação de uma linha de comissionamento...',
  criar_lista_de_comissionamento:
    'Preparando a criação de uma lista de comissionamento...',
  editar_lista_de_comissionamento:
    'Preparando a alteração de uma lista de comissionamento...',
  excluir_lista_de_comissionamento:
    'Preparando a exclusão de uma lista de comissionamento...',
  definir_variavel_de_comissionamento:
    'Preparando a definição de uma variável de comissionamento...',
  excluir_variavel_de_comissionamento:
    'Preparando a exclusão de uma variável de comissionamento...',
  // spec-002-pos-reuniao-follow-up [T044/T053]: a write-tool `agendar_proxima_
  // conversa` não tem cartão no registry (`tem_ui: false`) — o rótulo mora
  // aqui, byte a byte o `LABEL` de `tool_agendar_proxima_conversa.py`.
  agendar_proxima_conversa: 'Preparando o agendamento...',
  // Merge da `claude/release/ia-claude-code` em 21/09/2026: as três tools que o
  // backend trouxe de `claude/fix/envelope-memoria-run` levaram o contrato de
  // 142 para 145. Todas com `tem_ui: false` — o rótulo mora AQUI, e o texto é
  // byte a byte o `LABEL` de cada classe no backend (há teste que compara as
  // duas grafias).
  // ★ Sincronizar só o `tools-publicas.json` não basta: são DUAS juntas entre
  // backend e front, e só a primeira tem gate. Sem estas linhas o badge imprime
  // o nome interno cru no meio da conversa, sem erro e sem log — foi o que
  // aconteceu com `ler_anexo_analise` horas antes, no mesmo dia.
  gerar_planilha: 'Montando a planilha sob medida...',
  gerar_relatorio_pdf: 'Montando o relatório...',
  get_receita_do_profissional: 'Calculando a receita do profissional...',
  // [merge desenvolvimento, 21/09/2026] `gerar_grafico` — mesma junta, mesmo
  // motivo do comentário acima: o `tools-publicas.json` foi sincronizado pelo
  // gate, ESTA lista não tem gate nenhum. Texto idêntico ao `LABEL` da classe
  // no backend (`tool_gerar_grafico.py`).
  gerar_grafico: 'Desenhando o gráfico...',
}

// A lista pública de tools do backend — as que viram badge na tela.
//
// ★ DERIVADA do contrato, nunca redigitada ([T020] da spec-010). Até aqui eram
// 41 nomes escritos à mão, e lista escrita à mão não acusa a tool que nasceu
// ontem: o backend registrava, o badge imprimia o slug, e o teste de cobertura
// seguia verde porque o nome novo não estava na lista que ele mesmo mantinha
// (`list_pastas_tarefas` e `mover_tarefas` foram os dois casos medidos).
//
// O arquivo é gerado por `tests/test_tools_publicas_snapshot.py` no backend e
// copiado byte a byte para `ui-registry/contratos/` — `Text.tool-labels.unit.js`
// compara as duas cópias. `echo_test` não está lá de propósito: o gerador a
// exclui porque ela nunca sai no catálogo.
export const FRAMEWORK_TOOL_NAMES = toolsPublicas.tools.map((tool) => tool.nome)

// Lista canônica das 27 tools da persona Especialista em Comissionamento: as
// 13 de leitura da Fase 2 + as 14 da Fase 3 (`listar_blocos` e as 13 write-tools
// da configuração, atrás da flag `IA - Comissões - Ações`).
//
// As 27 nascem RESERVADAS no backend (`reservada=True, publica=False`) e são
// servidas só pela rota dedicada `/comissoes/chat`, atrás da flag
// `IA - Comissões`. Elas TAMBÉM estão em `FRAMEWORK_TOOL_NAMES` (o contrato
// `tools-publicas.json` inclui as reservadas, porque todas viram badge) — esta
// lista existe para o teste de cobertura poder dizer "estas 27 são as da
// persona", não para separá-las do contrato (NC-3 — nome interno de tool não
// chega à tela).
export const COMISSOES_TOOL_NAMES = [
  'criar_lista_de_comissionamento',
  'definir_variavel_de_comissionamento',
  'editar_linha_de_comissionamento',
  'editar_lista_de_comissionamento',
  'excluir_bloco_de_comissionamento',
  'excluir_linha_de_comissionamento',
  'excluir_lista_de_comissionamento',
  'excluir_variavel_de_comissionamento',
  'explicar_processo_comissionamento',
  'get_ajustes_manuais_comissionamento',
  'get_arquivos_importados_comissionamento',
  'get_base_de_clientes_comissionamento',
  'get_impostos_comissionamento',
  'get_lancamentos_do_fechamento',
  'get_listas_comissionamento',
  'get_minimos_garantidos_comissionamento',
  'get_regras_comissionamento',
  'get_relatorio_comissionamento',
  'get_trocas_de_campo_comissionamento',
  'get_variaveis_comissionamento',
  'inserir_bloco_de_comissionamento',
  'inserir_linha_de_comissionamento',
  'listar_blocos_de_comissionamento',
  'listar_valores_de_filtro_comissoes',
  'mover_bloco_de_comissionamento',
  'mover_linha_de_comissionamento',
  'renomear_bloco_de_comissionamento',
]

export const PROMPT_SUGGESTIONS_PROFISSIONAL = [
  { icon: 'mdi-calendar-today', text: 'O que preciso fazer hoje?' },
  { icon: 'mdi-alert-outline', text: 'Quais são minhas tarefas atrasadas?' },
  {
    icon: 'mdi-trending-up',
    text: 'Como está meu pipeline de vendas esse mês?',
  },
  {
    icon: 'mdi-account-search',
    text: 'Quais clientes estão sem atividade recente?',
  },
]

export const API_KEYS_TABLE_HEADERS = [
  { text: 'Nome', value: 'nome', sortable: true },
  { text: 'Chave', value: 'api_key_prefix', sortable: false },
  { text: 'Status', value: 'status', sortable: false, align: 'center' },
  { text: 'Último uso', value: 'ultimo_uso', sortable: true },
  { text: 'Expira em', value: 'expires_at', sortable: true },
  {
    text: '',
    value: 'actions',
    align: 'center',
    sortable: false,
    width: '80px',
  },
]

export const API_KEYS_TEXT = {
  pageTitle: 'Chaves de API',
  pageDescription:
    'Gere e gerencie suas chaves de acesso à API da IA Operacional. Cada chave dá acesso programático em seu nome. Guarde-a com segurança.',
  generateButton: 'Gerar chave',
  // Título/subtítulo do BaseTable (DS: toda listagem leva os dois — o
  // título da PÁGINA já vem do NavBarNavigation, este é o do bloco).
  tableTitle: 'Suas chaves',
  tableSubtitle: 'Chaves ativas e revogadas geradas em seu nome.',
  noData: 'Nenhuma chave ainda',
  noResults: 'Nenhuma chave encontrada',
  statusActive: 'Ativa',
  statusRevoked: 'Revogada',
  revokeTooltip: 'Revogar chave',
  revokeTitle: 'Revogar chave de API',
  revokeText:
    'Deseja revogar esta chave? Aplicações que a utilizam deixarão de funcionar imediatamente. Essa ação não pode ser desfeita.',
  revokeConfirm: 'Revogar',
  cancel: 'Cancelar',
  // Modal de criação
  createTitle: 'Gerar chave de API',
  fieldNameLabel: 'Nome da chave',
  fieldNamePlaceholder: 'Ex.: Integração CRM externo',
  fieldExpiresLabel: 'Data de expiração (opcional)',
  fieldExpiresInvalid: 'Data inválida. Use o formato DD/MM/AAAA.',
  generate: 'Gerar',
  close: 'Fechar',
  // Bloco da chave crua
  rawKeyTitle: 'Chave gerada com sucesso',
  rawKeyWarning: 'Copie agora: não será exibida novamente.',
  copy: 'Copiar',
  copied: 'Chave copiada',
  copyError: 'Não foi possível copiar. Copie manualmente.',
  // Seção de onboarding do Claude Code
  bundleSectionTitle: 'Configurar o Claude Code',
  bundleSectionDescription:
    'Em poucos passos você conecta seu Claude Code às tools do CRM da AAWZ usando esta chave.',
  bundleLoading: 'Carregando guia de configuração...',
  bundleError:
    'Não foi possível carregar o guia de configuração. Tente novamente mais tarde.',
  bundleInstallTitle: 'Configurar pelo Claude Code',
  bundleInstallDescription:
    'Copie o texto abaixo e cole no seu Claude Code. Ele vai baixar e configurar tudo sozinho. Você não precisa abrir o terminal.',
  bundleDownloadAlternative: 'Ou baixe os arquivos manualmente',
  bundleToolsTitle: 'Tools disponíveis para você',
  bundleExamplesTitle: 'Exemplos de uso',
  bundleExamples: [
    'Quais tarefas minhas estão atrasadas?',
    'Resumo do cliente João Silva',
    'Cria uma oportunidade pro cliente X',
  ],
  copyInstructions: 'Copiar instruções',
  instructionsCopied: 'Instruções copiadas',
  downloadBundle: 'Baixar bundle',
  bundleDownloaded: 'Arquivos baixados',
  bundleDownloadError: 'Não foi possível baixar os arquivos.',
  // Placeholder usado quando o guia é aberto sem uma chave recém-gerada
  rawKeyPlaceholder: 'aawzia_SUA_CHAVE_AQUI',
  bundleKeyPlaceholderNote:
    'Troque aawzia_SUA_CHAVE_AQUI pela chave que você gerou. Ela aparece só uma vez, no momento da criação.',
  // Botão e título do guia acessível a partir da lista de chaves
  guideButton: 'Como configurar o Claude Code',
  guideTitle: 'Conectar ao Claude Code',
  guideClose: 'Fechar',
}

export const PROMPT_SUGGESTIONS_GESTOR = [
  {
    icon: 'mdi-account-group',
    text: 'Como estão meus profissionais essa semana?',
  },
  { icon: 'mdi-podium-gold', text: 'Quem são meus top performers?' },
  {
    icon: 'mdi-funnel-outline',
    text: 'Como está o funil de vendas do escritório?',
  },
  {
    icon: 'mdi-alert-circle-outline',
    text: 'Quais tarefas estão em atraso no escritório?',
  },
]

// ─── Conhecimento oficial (spec-013-knowledge-por-escritorio-e-promocao-de-
// decisao, [T007]) ──────────────────────────────────────────────────────────
// Texto da aba "Conhecimento oficial" (`view-conhecimento.vue`, [T023]) — os 9
// tipos estruturados que o escritório mantém, consultáveis por
// (knowledge_type, code) sem LLM, ao lado da promoção de decisão a Knowledge.
export const CONHECIMENTO_TEXT = {
  pageTitle: 'Conhecimento oficial',
  pageDescription:
    'Regras, definições e decisões oficiais do escritório: o que a IA cita em vez de inventar',
  registrar: 'Registrar conhecimento',
  atualizar: 'Atualizar',
  encerrarVigencia: 'Encerrar vigência',
  reverter: (versao) => `Reverter para v${versao}`,
  filtroTipoLabel: 'Tipo',
  filtroStatusVigentes: 'Vigentes',
  filtroStatusHistorico: 'Histórico',
  filtroBuscaLabel: 'Buscar',
  noData:
    'Nenhum conhecimento oficial registrado. Comece por uma definição de métrica ou pelo calendário fiscal.',
  erroTitulo: 'Não foi possível carregar o conhecimento oficial',
  erro:
    'Não foi possível carregar o conhecimento oficial. Tente novamente ou contate o suporte.',
  tentarNovamente: 'Tentar de novo',
  proibidoTitulo: 'Acesso restrito',
  proibido: 'Esta área está disponível apenas para gestores do escritório.',
  encerrarMotivoLabel: 'Motivo do encerramento',
  encerrarMotivoObrigatorio: 'Informe o motivo (mínimo 5 caracteres).',
  encerrarConfirmar: 'Encerrar',
  salvo: 'Conhecimento oficial atualizado.',
}

// Espelho de `knowledge/tipos.py::KnowledgeType` — os 9 tipos de
// `contracts/knowledge-types.md` §1. Chave = `knowledge_type`; valor = label
// PT-BR, IDÊNTICO ao da tabela do contrato (fonte única do enum).
export const KNOWLEDGE_TYPE_LABELS = {
  metric_definition: 'Definição de métrica',
  accounting_policy: 'Política contábil',
  commission_rule: 'Regra de comissão',
  partnership_rule: 'Regra de partnership',
  fiscal_calendar: 'Calendário fiscal',
  investment_policy: 'Política de investimento',
  compliance_policy: 'Política de compliance',
  business_rule: 'Regra de negócio / decisão',
  chart_of_accounts_mapping: 'Mapeamento de plano de contas',
}

// Os 3 status de `aawz_intelligence_v2_knowledge_items.status`
// (`data-model.md` §2.1). `conhecimento-tabela.vue` ([T018]) decide a cor do
// `BaseStatus` a partir do valor — aqui só o texto, no molde de
// `RISCO_LABELS`/`RISCO_COLORS` (mapas separados, nunca combinados).
export const KNOWLEDGE_STATUS_LABELS = {
  active: 'Vigente',
  superseded: 'Substituída',
  archived: 'Encerrada',
}

// Os 4 `source_type` de `aawz_intelligence_v2_knowledge_items.source_type`.
export const KNOWLEDGE_SOURCE_LABELS = {
  gestor_manual: 'Decisão do gestor',
  advisory_decision: 'Decisão do Advisory Hub',
  module_reference: 'Referência a regra de módulo',
  importacao: 'Importação',
}

// `conhecimento-tabela.vue` ([T018]) — anatomia do `contracts/ui-
// components.md` §2: Tipo, Código, Nome, Versão, Vigência, Fonte, Atualizado
// por/em, Ações.
export const KNOWLEDGE_TABLE_HEADERS = [
  { text: 'Tipo', value: 'knowledge_type', sortable: true },
  { text: 'Código', value: 'code', sortable: true },
  { text: 'Nome', value: 'name', sortable: true },
  { text: 'Versão', value: 'version', sortable: true, align: 'center' },
  { text: 'Vigência', value: 'valid_from', sortable: true },
  { text: 'Fonte', value: 'source_type', sortable: false },
  { text: 'Atualizado por/em', value: 'updated_at', sortable: true },
  {
    text: '',
    value: 'actions',
    align: 'center',
    sortable: false,
    width: '96px',
  },
]

// ─── Curadoria de sugestões de IA (spec-003/005/006) ───────────────────────
// Arquivo próprio (`Text.curadoria.js`) — saiu daqui na chegada do [T021] da
// spec-007, que estourava o teto de 500 linhas. Mesmo padrão de `MEMORIA_TEXT`.
export {
  CURADORIA_CONFIANCA_LABEL,
  CURADORIA_CONFIANCA_OPTIONS,
  CURADORIA_CONFIANCA_TOOLTIP,
  CURADORIA_ORDENACAO_OPTIONS,
  CURADORIA_RESPONSAVEL_LABEL,
  CURADORIA_TEXT,
  CURADORIA_TIPO_ICON,
  CURADORIA_TIPO_LABEL,
  CURADORIA_TRIAGEM,
} from './Text.curadoria'

// Modal "Conectar WhatsApp" (canal WhatsApp da IA — modal/whatsapp-conectar).
export const WHATSAPP_CONECTAR_TEXT = {
  titulo: 'Conectar WhatsApp',
  intervaloPollingMs: 3000,
  exemplosDePerguntas: [
    'Quanto o cliente Roberto tem na XP?',
    'Quais minhas reuniões de hoje?',
    'Quais minhas tarefas de hoje?',
    'O que foi decidido na última reunião com a família Andrade?',
  ],
  // Só se o 403 vier sem `message` — a copy oficial é a do backend (gate.py).
  semAcessoFallback:
    'Seu escritório ainda não tem o canal WhatsApp da IA liberado. Fale com o responsável pela conta AAWZ do escritório.',
  snackConectado: 'WhatsApp conectado!',
  escrita: {
    chave: 'escrita_habilitada',
    rotulo: 'Permitir que a IA altere dados pelo WhatsApp',
    ajuda:
      'Criar ou editar tarefas, oportunidades e registros a partir de uma mensagem. A IA sempre mostra o resumo e só grava depois que você responder "sim".',
    snackLigada: 'Escrita pelo WhatsApp ligada. Toda alteração pede confirmação.',
    snackDesligada: 'Escrita pelo WhatsApp desligada.',
  },
  // Envios automáticos (uma coluna booleana por item no vínculo — v668+).
  // A `chave` TEM de ser o nome da coluna aceito pelo PATCH (core/preferencias.py).
  avisos: {
    titulo: 'Avisos automáticos',
    itens: [
      {
        chave: 'aviso_tarefas_hoje',
        rotulo: 'Tarefas do dia, às 8h',
        ajuda:
          'Toda manhã você recebe a lista das tarefas que vencem hoje. Sem tarefa, nada é enviado.',
        snackLigada: 'Aviso de tarefas do dia ligado.',
        snackDesligada: 'Aviso de tarefas do dia desligado.',
      },
    ],
  },
  snackPreferenciaFalhou: 'Não foi possível salvar a preferência.',
  // Onboarding pelo WhatsApp = a lista de espera do profissional (mesmo
  // questionário/tabela/flag `lista_espera` da web; `vinculo.pode_onboarding`).
  // Estados vêm de `vinculo.onboarding.status`: nenhum | em_andamento | concluido.
  onboarding: {
    titulo: 'Onboarding da operação',
    ajuda:
      'A IA encerra a conversa atual no WhatsApp e faz algumas perguntas sobre a sua operação por lá — pode responder por texto ou áudio.',
    botao: 'Iniciar onboarding pelo WhatsApp',
    confirmacao: {
      titulo: 'Iniciar onboarding pelo WhatsApp',
      texto:
        'A conversa atual com a IA no WhatsApp será encerrada e você receberá a primeira pergunta por lá. Continuar?',
      botao: 'Iniciar',
    },
    snackIniciado: 'Pronto! Confira a mensagem no seu WhatsApp.',
    snackFalhou: 'Não foi possível iniciar o onboarding.',
    statusEmAndamento: 'Onboarding em andamento no WhatsApp',
    statusConcluido: 'Onboarding concluído',
    statusFila: 'Onboarding concluído · você está na fila de espera',
  },
  snackDesconectado: 'WhatsApp desconectado.',
  confirmarDesconexao: {
    titulo: 'Desconectar WhatsApp',
    texto:
      'Este número deixará de receber respostas da IA. Você pode conectar de novo quando quiser.',
  },
}

// PDF do consolidador -> WhatsApp do próprio profissional (snack com ação e
// botão na aba de relatórios). As mensagens de resultado vêm do backend.
export const WHATSAPP_PDF_TEXT = {
  acao: 'Enviar para meu WhatsApp',
  botao: 'WhatsApp',
  enviando: 'Enviando para o seu WhatsApp…',
  fallbackErro: 'Não foi possível enviar o PDF para o WhatsApp.',
}
// Modais que CONECTAM as ferramentas DENTRO do chat (etapa 3 do onboarding,
// 19/09/2026) — `modal/conectar-email-agenda`, `modal/conectar-whatsapp` e
// `modal/conectar-whatsapp-qrcode`.
export {
  CONECTAR_EMAIL_AGENDA_TEXT,
  CONECTAR_WHATSAPP_QRCODE_TEXT,
  CONECTAR_WHATSAPP_TEXT,
  SELO_DE_ESCOPO,
} from './Text.conectores'
